import { render, staticRenderFns } from "./Covid.vue?vue&type=template&id=3381ccbc&scoped=true&"
import script from "./Covid.vue?vue&type=script&lang=js&"
export * from "./Covid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381ccbc",
  null
  
)

export default component.exports